module.exports = __webpack_public_path__ + "img/icon-lmp-favicon.38d8fec2.svg";